import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-ssr',
  templateUrl: './ssr.component.html',
  styleUrls: ['./ssr.component.scss']
})
export class SsrComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
